import React, { Component } from 'react';
import { TextField, MenuItem, CircularProgress, Typography, Icon, Fab, Tooltip, Grid } from '@material-ui/core';

import { connect } from 'react-redux';


import categoryService from '../../api/categoryService';
import questionsService from '../../api/questionsService';
import QuestionsList from './QuestionsList';
import QuestionForm from './QuestionForm';

class QuestionsScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            selectedCategory: '',
            selectedSubcategory: '',
            questions: [],
            showCreateQuestion: false
        };

        this._selectCategory = this._selectCategory.bind(this);
        this._selectSubcategory = this._selectSubcategory.bind(this);
        this._setShowCreateQuestion = this._setShowCreateQuestion.bind(this);
    }

    async componentDidMount() {
        const { categories } = this.props;
        if (categories.length <= 0) {
            await categoryService.getAllCategories();
        }

        this.setState({
            loading: false
        });
    }

    _setShowCreateQuestion(value) {
        this.setState({
            showCreateQuestion: value
        });
    }

    _selectCategory = ({ target }) => {
        this.setState({
            selectedCategory: target.value,
            selectedSubcategory: ''
        });
    }

    _selectSubcategory = ({ target }) => {
        this.setState({
            selectedSubcategory: target.value
        });

        if (Boolean(target.value)) {
            questionsService.getQuestionsByCategory(target.value);
        }
    }

    render() {
        const { categories } = this.props;

        if (this.state.loading) {
            return (
                <div style={{ display: 'flex', flex: 1, flexGrow: 1, height: '100%', justifyContent: 'center', alignItems: 'center' }}>
                    <CircularProgress color="secondary" />
                </div>
            );
        }

        return (
            <div>
                <section style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

                    <TextField
                        select
                        label="Category"
                        value={this.state.selectedCategory}
                        onChange={this._selectCategory}
                        fullWidth
                        SelectProps={{
                            MenuProps: {
                                style: { width: '100%' }
                            },
                        }}
                        style={{ paddingLeft: 5, paddingRight: 5 }}
                        margin="normal"
                        variant="outlined"
                    >
                        {
                            categories.map((cat) => {
                                return (<MenuItem key={cat.id} value={cat.id}>{cat.name}</MenuItem>);
                            })
                        }
                    </TextField>

                    <TextField
                        select
                        label="Subcategory"
                        value={this.state.selectedSubcategory}
                        onChange={this._selectSubcategory}
                        fullWidth
                        style={{ paddingLeft: 5, paddingRight: 5 }}
                        SelectProps={{
                            MenuProps: {
                                style: { width: '100%' }
                            },
                        }}
                        margin="normal"
                        variant="outlined"
                    >
                        {
                            this.state.selectedCategory !== '' ?
                                categories.filter((cat) => cat.id === this.state.selectedCategory)[0].subcategories
                                    .map((subcat) => {
                                        return (<MenuItem key={subcat.id} value={subcat.id}>{subcat.name}</MenuItem>);
                                    })
                                :
                                <MenuItem value={""}>Choose a category...</MenuItem>
                        }
                    </TextField>

                    <Tooltip title={this.state.selectedSubcategory !== '' ? "Add a new question for selected category" : "Select a category to add a new question."}>
                        <div>
                            <Fab disabled={this.state.selectedSubcategory === ''} color="secondary" variant="round" onClick={() => {
                                this._setShowCreateQuestion(true);
                            }}>
                                <Icon>add</Icon>
                            </Fab>
                        </div>
                    </Tooltip>

                </section>
                {
                    this.state.selectedSubcategory === '' ?
                        <Typography variant="body1">Choose a Subcategory to visualize the questions.</Typography>
                        :
                        <QuestionsList showModal={() => {
                            this._setShowCreateQuestion(true);
                        }} />
                }

                <QuestionForm
                    showModal={this.state.showCreateQuestion}
                    category={this.state.selectedCategory}
                    subcategory={this.state.selectedSubcategory}
                    hideModal={() => {
                        this._setShowCreateQuestion(false);
                    }} />
            </div>
        )
    }
}


const mapStateToProps = ({ categoryState }) => ({
    categories: categoryState.categories
});

export default connect(mapStateToProps)(QuestionsScreen);